import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#011a3c",
      secondary: "#63C6A2",
      text: "#2D3748",
      gray: "#A0AEC0",
    },
  },
  typography: {
    fontFamily: "Helvetica",
  },
});
